import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  content: React.ReactNode | null | undefined
}

// Exclude `false` or `null` children
const notEmptyChildren = (children: React.ReactNode[]): React.ReactNode => {
  return children.filter((child) => !!child)
}

const Content = ({ children }: React.PropsWithChildren) => (
  <Box
    className={'Footer_Footer'}
    justifyContent="flexEnd"
    alignItems="center"
    flexDirection="row"
    flexWrap="wrap"
    gap="s8"
  >
    {children}
  </Box>
)

const Footer = ({ content }: Props) => {
  if (!content) return null

  const firstElement = React.Children.only(content) as React.ReactElement<{
    children: React.ReactNode[]
  }>

  const isFragment = typeof content === 'object' && firstElement.type === React.Fragment

  if (isFragment) {
    const children = notEmptyChildren(firstElement.props.children)

    // Fragment with an array of [null, false, ...]
    if (!React.Children.toArray(children).length) return null

    return <Content>{children}</Content>
  }

  return <Content>{content}</Content>
}

export default Footer
